import { render } from "./DisciplineDashboard.vue?vue&type=template&id=2f56453a&scoped=true"
import script from "./DisciplineDashboard.vue?vue&type=script&lang=js"
export * from "./DisciplineDashboard.vue?vue&type=script&lang=js"

import "./DisciplineDashboard.vue?vue&type=style&index=0&id=2f56453a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f56453a"]])

export default __exports__